var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0659 10.6517C43.0964 11.0781 43.0964 11.5046 43.0964 11.9309C43.0964 24.9359 33.198 39.9208 15.1066 39.9208C9.53297 39.9208 4.35534 38.3065 0 35.5046C0.791906 35.5959 1.55325 35.6264 2.37562 35.6264C6.97453 35.6264 11.2081 34.0731 14.5888 31.4233C10.2639 31.3319 6.63956 28.4995 5.39081 24.601C6 24.6923 6.60909 24.7532 7.24875 24.7532C8.13197 24.7532 9.01528 24.6313 9.83756 24.4183C5.32997 23.5045 1.94916 19.5451 1.94916 14.7634V14.6416C3.25875 15.3726 4.78172 15.8294 6.39581 15.8903C3.74606 14.1238 2.01009 11.1086 2.01009 7.69738C2.01009 5.87 2.49731 4.19488 3.35016 2.73294C8.19281 8.70247 15.472 12.6009 23.6344 13.0273C23.4821 12.2964 23.3907 11.535 23.3907 10.7736C23.3907 5.35222 27.7765 0.936035 33.2283 0.936035C36.0607 0.936035 38.6191 2.12385 40.4161 4.04263C42.6394 3.61625 44.7713 2.79388 46.6597 1.667C45.9287 3.95132 44.3754 5.8701 42.3349 7.08829C44.3146 6.87519 46.2334 6.32685 47.9998 5.5655C46.6599 7.51466 44.9847 9.25063 43.0659 10.6517Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.81dc6f35171b39f4d8859e49fb35fdf1.svg";
export { ForwardRef as ReactComponent };